// extracted by css-extract-rspack-plugin
module.exports =  {"container":"EditColumnsModal-Wf9t__container"};